export default __webpack_public_path__ + "static/media/iconLink.bfc48ca6.svg";